import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'amfe-flexible';
import '@/assets/common.css';
import 'vant/lib/index.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { setDocumentTitle, initSysConfig } from '@/utils/tool.js';
import { Loading, Toast, Tab, Tabs, List, DropdownMenu, DropdownItem } from 'vant';

// CSP、monitor等
// initSysConfig()

Vue.use(Loading);
Vue.use(Toast);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(List);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.$toast = Toast;

router.afterEach((to) => {
  // 设置页标题
  setDocumentTitle(to.meta.title);
});

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
